import React, {useEffect} from "react";
import {useState} from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import {Form, Formik} from "formik";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../apiService";
import Alert from "../component/Alert";

const ModalClinicModule = ({show, onHide, resetData, refreshModal, clinic, refModules, refParamedic}) => {

    const [data, setData] = useState([])
    const [deletedData, setDeletedData] = useState([])
    const [newModules, setNewModules] = useState([])
    const [newParamedics, setNewParamedics] = useState([])

    useEffect(() => {
        if (clinic) {
            setData(clinic.module_clinics)
            setDeletedData([])
            setNewModules([])
            setNewParamedics([])
        }
    }, [JSON.stringify(clinic), refreshModal])

    const add = () => {
        setData([...data, {
            id: (Math.random() + 1).toString(36).substring(7),
            isNew: true,
            moduleId: refModules.length ? refModules[0].id : '',
            paramedicId: refParamedic.length ? refParamedic[0].id : '',
        }])
    }

    const postData = async () => {
        const res = await API.put("management/module_clinics/set", {
            clinic_id: clinic.id,
            new: data.filter(v => v.isNew).map(v => ({module_id: v.moduleId, paramedic_id: v.paramedicId})),
            deleted: deletedData
        })
        if (res.code === 200) {
            Alert("success", "Berhasil mengedit akses");
            onHide()
            resetData()
        }
    }

    const deleteNew = (id) => {
        let filtered = []
        data.forEach(v => {
            if (v.isNew) {
                if (v.id !== id) {
                    filtered.push(v)
                }
            }
            else {
                filtered.push(v)
            }
        })
        setData(filtered)
    }

    const deleteExisting = (newDeletedIds) => {
        let filtered = []
        data.forEach(v => {
            if (v.isNew) {
                filtered.push(v)
            }
            else {
                let isDeleted = false
                for (const id of newDeletedIds) {
                    if (+v.id === +id) {
                        isDeleted = true
                        break
                    }
                }
                if (!isDeleted) {
                    filtered.push(v)
                }
            }
        })
        setData(filtered)
    }

    const toRow = (v, k) => {
        if (v.isNew) {
            return (
                <tr key={`r-${k}`}>
                    <td>{k + 1}<br/><label className={'badge badge-success'}>Baru</label></td>
                    <td>
                        <select
                            className="form-control"
                            onChange={(e) => {
                                let old = [...data]
                                for (const q of old) {
                                    if (q.id === v.id) {
                                        q.moduleId = e.target.value
                                    }
                                }
                                setData(old)
                            }}
                            value={data.find(q => v.id === q.id)?.moduleId ?? ''}
                        >
                            {refModules.map((a, b) => (<option value={a.id} key={`opt-${b}-${k}`}>{a.name}</option>))}
                        </select>
                    </td>
                    <td>
                        <select
                            className="form-control"
                            onChange={(e) => {
                                let old = [...data]
                                for (const q of old) {
                                    if (q.id === v.id) {
                                        q.paramedicId = e.target.value
                                    }
                                }
                                setData(old)
                            }}
                            value={data.find(q => v.id === q.id)?.paramedicId ?? ''}
                        >
                            {refParamedic.map((a, b) => (<option value={a.id} key={`opt-${b}-${k}`}>{a.name}</option>))}
                        </select>
                    </td>
                    <td>
                        <button
                            type="button"
                            className={'btn btn-sm btn-outline-danger mt-2'}
                            onClick={() => deleteNew(v.id)}
                        >
                            <i className={'fa fa-trash'}/>
                        </button>
                    </td>
                </tr>
            )
        }

        return (
            <tr key={`r-${k}`}>
                <td>{k + 1}</td>
                <td>{v.modules.name}</td>
                <td>{v.paramedic_types.name}</td>
                <td>
                    <button
                        type="button"
                        className={'btn btn-sm btn-outline-danger'}
                        onClick={() => {
                            const n = [...deletedData, v.id]
                            setDeletedData(n)
                            deleteExisting(n)
                        }}
                    >
                        <i className={'fa fa-trash'}/>
                    </button>
                </td>
            </tr>
        )
    }

    return (
        <Modal
            show={show}
            size={'lg'}
            aria-labelledby="modal-user"
            onHide={() => {
                onHide()
                // resetData()
            }}
        >
            <ModalHeader closeButton>
                <ModalTitle>
                    <h3>Edit Data Clinic Module</h3>
                </ModalTitle>
            </ModalHeader>
            <Formik
                enableReinitialize
                initialValues={{
                    name: clinic?.name ?? '',
                }}
                onSubmit={(values) => {
                    postData()
                }}
            >
                {({ values, errors, touched }) => (
                    <Form>
                        <ModalBody>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-5 col-form-label col-form-label-sm"
                                >
                                    Clinic
                                </label>
                                <div className="col-md-7">
                                    <div className="row">
                                        <input
                                            className="form-control form-control-sm"
                                            type="text"
                                            placeholder="Nama medis/paramedis"
                                            name="name"
                                            id="name"
                                            value={clinic.name}
                                            readOnly={true}
                                        />
                                        {errors.name && touched.name ? (
                                            <div style={{ color: "red" }}>{errors.name}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <table className={'table table-bordered'}>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Module</th>
                                        <th>Paramedic</th>
                                        <th>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.map(toRow)}
                                </tbody>
                            </table>
                            <button type="button" className={'btn btn-outline-success btn-sm mt-1'} onClick={add}>
                                Tambah
                            </button>
                        </ModalBody>
                        <ModalFooter>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            onHide()
                                            // resetData()
                                        }}
                                        className="btn btn-outline-secondary"
                                    >
                                        Batal
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </ModalFooter>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}

export default ModalClinicModule